import { useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

import BackLinkButton from '../components/BackLinkButton.jsx';
import UserHeader from '../components/UserHeader.jsx';
import SendRequestButton from '../components/SendRequestButton.jsx';
import LoaderModal from '../components/LoaderModal.jsx';

import justLogo from '../images/justlogo500.png';

const RobaDetails = () => {

  const { objectId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const distance = queryParams.get('distance');

  const token = localStorage.getItem('loggedUser');
  const decodedToken = jwtDecode(token);

  //----- CHIAMATA FETCH PER I DATI DELL'OGGETTO -----//

  const [objectData, setObjectData] = useState(null);
  const [isFetchPending, setIsFetchPending] = useState(false);
  const [isPickedDone, setIsPickedDone] = useState(false);

  const getObjectDetails = async () => {

    try {
      setIsFetchPending(true);
      const res = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/roba/${objectId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if(res.ok) {
        const object = await res.json();
        setObjectData(object.payload);
      } else {
        console.log('Errore durante la chiamata al server');
      }
    } catch (error) {
      console.log('Error type: ', error);
    }
    setIsFetchPending(false);
  }

  useEffect(() => {
    getObjectDetails();
  }, [])

  useEffect(() => {
    console.log('objectData: ', objectData);
  }, [objectData]);

  //-----//

  //----- CHIAMATA PER ANNULLARE LA RICHIESTA -----//

  const [isExchangeDelete, setIsExchangeDelete] = useState(false);
  const [isObjectUnpicked, setIsObjectUnpicked] = useState(false);
  const [isWrongFetch, setIsWrongFetch] = useState(false);

  const deleteRequest = async () => {

    setIsFetchPending(true);

    // Cancello da Exchanges
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/deleteExchange/${objectId}/${decodedToken.id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if(res.ok) {
        const deleteObject = await res.json();
        console.log(deleteObject.message)
        setIsExchangeDelete(true);
      } else {
        console.log('Errore exchange delete: ', res);
        setIsWrongFetch(true);
      }
    } catch (error) {
      console.log('Error Type', error);
      setIsWrongFetch(true);
    }
    // Setto picked 'false' su Roba
    try {
      const res = await fetch((`${process.env.REACT_APP_SERVER_BASE_URL}/roba/unpickByTaker/${decodedToken.id}/${objectId}`), {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if(res.ok) {
        const unpickedObject = await res. json();
        console.log('unpickedObject: ', unpickedObject);
        setIsObjectUnpicked(true);
      } else {
        console.log('Errore unpick object: ', res);
        setIsWrongFetch(true);
      }
    } catch (error) {
      console.log('Error Type: ', error);
      setIsWrongFetch(true);
    }

    setIsFetchPending(false);
  }


  //-----//


  return (
    <div className="container">
      <img src={justLogo} style={{width: '50px'}}/><h2>DETTAGLI OGGETTO</h2>
      <BackLinkButton />

      {objectData ? (

        <div className={objectData.picked.isPicked ? (objectData.picked.pickerId === decodedToken.id ? 'border-box picked-by-me' : 'border-box picked') : 'border-box'}>
          
          {(objectData.picked.isPicked && !isObjectUnpicked) ? (
            
            objectData.picked.pickerId === decodedToken.id ? (
              <div className={'picked-div-alert-by-me'}>
                <div>Hai inviato una richiesta per questo oggetto</div>
                <button onClick={deleteRequest}>Annulla richiesta</button>
              </div>
            ) : (
              <div className={'picked-div-alert'}>Questo oggetto è già stato richiesto</div>
            )

          ) : (

            <div>
              {isObjectUnpicked && <h2 style={{ color: '#94A684'}}>Richiesta eliminata con successo</h2>}
              {isWrongFetch && <h2 style={{ color: '#C63D2F'}}>Qualcosa è andato storto. Ricarica la pagina e riprova.</h2>}
            </div>

          )

          }

          <h2>{objectData.robaName}</h2>

          <p className="dark-grey">(L'oggetto si trova a <span style={{color: '#C63D2F'}}>{distance}</span> km da casa tua)</p>

          <img className="roba-details-img" src={objectData.photo.url} />

          <h4>Descrizione:</h4>
          <div className="object-description">
            <p>{objectData.description}</p>
          </div>

          <h4 style={{'margin-bottom': '-15px'}}>Oggetto messo in offerta da:</h4>

          <UserHeader user={{
            id: objectData.supplier._id,
            avatarUrl: objectData.supplier.avatar.url,
            name: objectData.supplier.name,
            surname: objectData.supplier.surname,
            position: objectData.supplier.position,
          }}
          />


          <button>Fa' una domanda a {objectData.supplier.name}</button>

          <br />

          {!isPickedDone ? (
            <SendRequestButton
            objectId={objectData._id}
            supplierId={objectData.supplier._id}
            picked={objectData.picked.isPicked}
            userToken={token}
            isFetchPending={isFetchPending}
            setIsFetchPending={setIsFetchPending}
            isPickedDone={isPickedDone}
            setIsPickedDone={setIsPickedDone}
            />
          ) : (
            <h2>Hai inviato una richiesta per questo oggetto</h2>
          )}


        </div>

      ) : (
        <></>
      )
    }

    {isFetchPending && <LoaderModal isFetchPending={isFetchPending} />}

    </div>
  )
}

export default RobaDetails;
